import getWithToken from './base/get-with-token'

const getUsersListDropDown = getWithToken('/user-dropdown')

export default getUsersListDropDown